import { isOnEditorX, isOnWixStudio } from '..';
const getFreeDomainUrlPart = (urlFormat) => {
    if (isOnWixStudio()) {
        return 'wixstudio.com';
    }
    if (isOnEditorX()) {
        return 'editorx.io';
    }
    if (urlFormat.isSlash()) {
        return 'wixsite.com';
    }
    return 'wix.com';
};
export const isDomainConnected = (urlFormat, url) => {
    if (!urlFormat)
        return false;
    const freeDomainUrlPart = getFreeDomainUrlPart(urlFormat);
    return Boolean(url && !url.includes(freeDomainUrlPart));
};
